module.exports = __webpack_public_path__ + "img/3.a55136a3.png";